import Icon from '@assets/images/Hero-Icone.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './BrandSuitabilityFive.style';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BrandSuitabilityFive = () => {
  const { t, i18n } = useTranslation('brandSuitability');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>
          {t('brandSuitabilityFive.title.spanBefore')}
          {i18n.language !== 'en' && <span>2</span>}{' '}
          {t('brandSuitabilityFive.title.spanAfter')}
        </h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <p>
            {t('brandSuitabilityFive.subtitle.spanBefore')}
            <span>2</span> {t('brandSuitabilityFive.subtitle.spanAfter')}
          </p>
          <ul>
            <li>{t('brandSuitabilityFive.ul.liOne')}</li>
            <li>{t('brandSuitabilityFive.ul.liTwo')}</li>
            <li>{t('brandSuitabilityFive.ul.liThree')}</li>
          </ul>
          <Link to="/contato" className="link-with-icon">
            <button>{t('brandSuitabilityFive.button')}</button>
          </Link>
        </TextBox1>
        <ImageBox>
          <img src={Icon} alt="Imagem" />
        </ImageBox>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default BrandSuitabilityFive;
